
export default {
  beforeDestroy() {
    if (this.mainContainer) {
      this.mainContainer.removeEventListener('keydown', this.keyDownNavigation);
    }
  },
  data() {
    return {
      mainContainer: null,
      currentMatchIndex: 0,
      matches: [],
      matchCount: 0,
      refs:{},
      refCollapses: []
    }
  },
  computed: {
    currentIndex() {
      return this.currentMatchIndex + 1;
    },
    disabledNextMatchButton() {
      return (this.currentMatchIndex + 1 ) >= this.matches.length;
    },
    disabledPrevMatchButton() {
      return (this.currentMatchIndex - 1 ) < 0;
    },
    matchesExists() {
      return (this.matchCount > 0);
    }
  },
  methods: {
    checkIfCollapseIsOpen(keyRef) {
      const refCollapseComponent = this.refs[keyRef];
      const [refCollapseComponentChildren] = refCollapseComponent.$children;

      if (!refCollapseComponentChildren.visible) {
        refCollapseComponentChildren.show = true;
      }
    },
    initSearchMatchesData(){
      this.currentMatchIndex = 0;
      this.matches = [];
      this.matchCount = 0;
    },
    keyDownNavigation(event) {
      if (!this.matchCount) {
         return;
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.nextMatch();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.prevMatch();
      }
    },
    nextMatch() {
      if (!this.matchCount) {
        return;
      }

      const nextIndex = (this.currentMatchIndex + 1) % this.matches.length;

      this.scrollToMatch(nextIndex);
    },
    prevMatch() {
      if (!this.matchCount) {
        return;
      }

      const prevIndex = (this.currentMatchIndex - 1 + this.matches.length) % this.matches.length;

      this.scrollToMatch(prevIndex);
    },
    scrollToMatch(index) {
      if (!this.matchCount) {
        return;
      }

      this.currentMatchIndex = index;

      const mark = this.matches[index];


      if (this.mainContainer && mark) {
        const containerRect = this.mainContainer.getBoundingClientRect();
        const markRect      = mark.getBoundingClientRect();
        const offsetTop     = markRect.top - containerRect.top + this.mainContainer.scrollTop;
        const offsetLeft    = markRect.left - containerRect.left + this.mainContainer.scrollLeft;

        this.mainContainer.scrollTo({
          top: offsetTop - (this.mainContainer.clientHeight / 2),
          left: offsetLeft - (this.mainContainer.clientWidth / 2),
          behavior: 'smooth'
        });
      }

      this.matches.forEach((match, index) => {
        match.style.backgroundColor = (index === this.currentMatchIndex)
        ? 'rgba(255, 200, 0, 0.5)'
        : 'rgba(27, 61, 94, .25)';
      });
    },
    searchMatches(refComponent, searchText, keyRef) {
      if (!this.mainContainer) {
        return;
      }



      // Limpiar highlights anteriores
      const prevMarks = refComponent.querySelectorAll('mark.__highlight');

      prevMarks.forEach(mark => {
        const parent = mark.parentNode;

        parent.replaceChild(document.createTextNode(mark.textContent), mark);
        parent.normalize();
      });

      if (!searchText) {
        return;
      }

      const regex = new RegExp(searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi');
      const textNodes = [];
      let totalMatches = 0;

      // Recolectar todos los nodos de texto
      const walker = document.createTreeWalker(refComponent, NodeFilter.SHOW_TEXT, null, false);
      let node;

      while ((node = walker.nextNode())) {
        if (node.nodeValue.trim() !== '') {
          textNodes.push(node);
        }
      }

      const martchesArray = [];

      // Para cada nodo de texto, encontrar coincidencias y aplicar highlight
      textNodes.forEach(node => {
        const matches = [];
        let match;

        while ((match = regex.exec(node.nodeValue)) !== null) {
          matches.push({ index: match.index, length: match[0].length });
        }

        totalMatches += matches.length

        if (matches.length > 0) {
          const frag = document.createDocumentFragment();
          let lastIndex = 0;

          matches.forEach(m => {
            frag.appendChild(document.createTextNode(node.nodeValue.slice(lastIndex, m.index)));

            const mark = document.createElement('mark');

            mark.className = '__highlight';
            mark.style.backgroundColor = 'rgba(27, 61, 94, .25)';
            mark.textContent = node.nodeValue.substr(m.index, m.length);

            frag.appendChild(mark);
            martchesArray.push(mark);

            lastIndex = m.index + m.length;
          });

          frag.appendChild(document.createTextNode(node.nodeValue.slice(lastIndex)));
          node.replaceWith(frag);
        }
      });

      if (totalMatches) {
        this.checkIfCollapseIsOpen(keyRef);
      }

      this.matchCount+= totalMatches;
      this.matches = [...this.matches, ...martchesArray];

      if (this.matches.length) {
        requestAnimationFrame(() => {
          this.scrollToMatch(0);
        });
      }
    },
    setMainContainer(mainContainer) {
      this.mainContainer = mainContainer;

      this.mainContainer.addEventListener('keydown', this.keyDownNavigation);
    },
    setRefs(refs) {
      this.refs = refs;
    }
  }
}
